const BooksIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M3.75 7.5H8.25V4.5C8.25 4.30109 8.17098 4.11032 8.03033 3.96967C7.88968 3.82902 7.69891 3.75 7.5 3.75H4.5C4.30109 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30109 3.75 4.5V7.5Z'
                fill='#827CA8'
            />
            <path
                opacity='0.2'
                d='M8.25 16.5H12.75V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75H9C8.80109 3.75 8.61032 3.82902 8.46967 3.96967C8.32902 4.11032 8.25 4.30109 8.25 4.5V16.5Z'
                fill='#827CA8'
            />
            <path
                opacity='0.2'
                d='M16.05 16.7998L20.4 15.6279L21.1782 18.5248C21.2036 18.6202 21.21 18.7197 21.1969 18.8176C21.1838 18.9155 21.1515 19.0098 21.1018 19.0952C21.0522 19.1805 20.9862 19.2553 20.9076 19.315C20.829 19.3748 20.7393 19.4185 20.6438 19.4436L17.7469 20.2217C17.5555 20.2734 17.3514 20.2472 17.1792 20.1488C17.007 20.0504 16.8808 19.8879 16.8282 19.6967L16.05 16.7998Z'
                fill='#827CA8'
            />
            <path
                opacity='0.2'
                d='M13.7248 8.09996L18.0748 6.93746L17.2966 4.04058C17.2439 3.84902 17.1181 3.68577 16.9463 3.58587C16.7746 3.48597 16.5705 3.45737 16.3779 3.50621L13.481 4.28433C13.2894 4.33711 13.1262 4.46287 13.0263 4.63464C12.9264 4.8064 12.8978 5.01048 12.9466 5.20308L13.7248 8.09996Z'
                fill='#827CA8'
            />
            <path
                d='M7.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H7.5C7.91421 20.25 8.25 19.9142 8.25 19.5V4.5C8.25 4.08579 7.91421 3.75 7.5 3.75Z'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3.75 7.5H8.25'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12 3.75H9C8.58579 3.75 8.25 4.08579 8.25 4.5V19.5C8.25 19.9142 8.58579 20.25 9 20.25H12C12.4142 20.25 12.75 19.9142 12.75 19.5V4.5C12.75 4.08579 12.4142 3.75 12 3.75Z'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.25 16.5H12.75'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.3734 3.5099L13.4757 4.28635C13.0756 4.39356 12.8381 4.80481 12.9453 5.20491L16.8276 19.6938C16.9348 20.0939 17.3461 20.3313 17.7462 20.2241L20.644 19.4477C21.0441 19.3405 21.2815 18.9292 21.1743 18.5291L17.292 4.04023C17.1848 3.64013 16.7735 3.40269 16.3734 3.5099Z'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.05 16.7998L20.4 15.6279'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.7251 8.1L18.0751 6.9375'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default BooksIcon;
